module.exports = __webpack_public_path__ + "static/img/18.481f620.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/18.png
// module id = +Lyy
// module chunks = 0